export default "__VITE_ASSET__FL8Qc1ZL__"